module.exports = __webpack_public_path__ + "static/media/logo-mono.50a5a72e.svg";